<template>
  <div>
    <div class="modal fade" id="register-shipping-info-modal" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="m-t-none m-b-none"><strong>発送元情報登録</strong></h4>
            <div class="form-register p-xl">
              <form>
                <div class="form-group">
                  <label for="name">発送元名（企業名、氏名など）</label><span class="label-required">必須</span>
                  <input type="text" v-model.trim="formRegisterData.name" class="form-control" id="name">
                  <div v-if="validateErrors.name" class="text-red"><b>{{ validateErrors.name }}</b></div>
                </div>
                <div class="form-group">
                  <label for="postalcode">郵便番号</label><span class="label-required">必須</span>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" v-model.trim="formRegisterData.postalCode" class="form-control" id="postalcode" placeholder="ハイフンなし">
                    </div>
                    <div class="col-md-6">
                      <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="searchAddressByPostalCode()">住所検索</button>
                    </div>
                  </div>
                  <div v-if="validateErrors.postalCode" class="text-red"><b>{{ validateErrors.postalCode }}</b></div>
                </div>
                <div class="form-group">
                  <label for="address">都道府県</label><span class="label-required">必須</span>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.prefecture" class="form-control" id="prefecture" autocomplete="off">
                  </div>
                  <div v-if="validateErrors.prefecture" class="text-red"><b>{{ validateErrors.prefecture }}</b></div>
                </div>
                <div class="form-group">
                  <label for="address1">住所1</label><span class="label-required">必須</span>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.address1" class="form-control" id="address1" autocomplete="off" @input="handleChangeAddress()" @focus="handleFocusAddress()" @blur="handleBlurAddress()">
                    <div v-if="showAddressList" class="box-address-list">
                      <ul class="address-list list-group">
                        <a v-for="(address, addressIndex) in addressList" :key="addressIndex" href="javascript:void(0)" :class="['address-item list-group-item list-group-item-action', formRegisterData.address1 === address ? 'active' : '']" @click.prevent="chooseAddressItem(address)">{{ address }}</a>
                      </ul>
                    </div>
                  </div>
                  <div>※住所検索時は続きをご入力ください</div>
                  <div v-if="validateErrors.address1" class="text-red"><b>{{ validateErrors.address1 }}</b></div>
                </div>
                <div class="form-group">
                  <label for="address2">住所2（住所1のつづき）</label><span class="label-any">任意</span>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.address2" class="form-control" id="address2" autocomplete="off">
                  </div>
                  <div v-if="validateErrors.address2" class="text-red"><b>{{ validateErrors.address2 }}</b></div>
                </div>
                <div class="form-group">
                  <label for="phone-number">電話番号</label><span class="label-required">必須</span>
                  <input type="text" v-model.trim="formRegisterData.phoneNo" class="form-control" id="phone-number">
                  <div v-if="validateErrors.phoneNo" class="text-red"><b>{{ validateErrors.phoneNo }}</b></div>
                </div>
                <div class="text-center m-t-lg">
                  <button type="button" class="btn btn-basic custom-btn-delivery m-r-sm" data-dismiss="modal" @click="$emit('close')">閉じる</button>
                  <button type="button" class="btn btn-warning custom-btn-delivery check-maintenance" @click.prevent="handleSubmit()">{{ submitText }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'
import WarehouseScService from '@/services/warehousescservice'
import store from '@/store'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      formRegisterData: {
        name: '',
        postalCode: '',
        prefecture: '',
        address1: '',
        address2: '',
        phoneNo: ''
      },
      showAddressList: false,
      addressList: [],
      requiredMessage: '※必須項目です',
      validateFields: [
        { key: 'name', limit: 150, message: '※{limit}文字以内でご入力ください' },
        { key: 'postalCode', limit: 10, message: '※半角数値、またはハイフン（-）で{limit}文字以内でご入力ください', regex: /^[0-9-]+$/ },
        { key: 'prefecture', limit: 10, message: '※{limit}文字以内でご入力ください' },
        { key: 'address1', limit: 100, message: '※{limit}文字以内でご入力ください' },
        { key: 'address2', limit: 100, message: '※{limit}文字以内でご入力ください' },
        { key: 'phoneNo', limit: 30, message: '※半角数値、またはハイフン（-）で{limit}文字以内でご入力ください', regex: /^[0-9-]+$/ }
      ],
      validateErrors: {
        name: '',
        postalCode: '',
        prefecture: '',
        address1: '',
        address2: '',
        phoneNo: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      currentInfoSeq: 'scshippingmultichannelinfo/getCurrentSeq',
      selectedInfoItem: 'scshippingmultichannelinfo/getSelectedItem'
    }),
    submitText () {
      let text = '登録する'
      if (this.selectedInfoItem && Object.keys(this.selectedInfoItem).length) {
        text = '変更する'
      }
      return text
    }
  },
  methods: {
    handleChangeAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleFocusAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleBlurAddress () {
      setTimeout(() => {
        this.showAddressList = false
      }, 400)
    },
    chooseAddressItem (address) {
      this.formRegisterData.address1 = address
      this.showAddressList = false
    },
    async searchAddressByPostalCode () {
      if (this.validateSubmit(this.validateFields.filter(field => field.key === 'postalCode'))) {
        return false
      }

      this.addressList = []
      this.loader = this.$loading.show()
      await DeliveryInfoSellerService.searchAddressByPostalCode({ postalcode: this.formRegisterData.postalCode.replace(/-/g, '') })
        .then((response) => {
          let results = response.data
          if (results && results.length) {
            this.formRegisterData.prefecture = `${results[0]['address1']}`
            this.formRegisterData.address1 = `${results[0]['address2']} ${results[0]['address3']}`
            if (results.length === 1) {
              this.showAddressList = false
            } else {
              results.filter((item) => {
                this.addressList.push(`${item['address2']} ${item['address3']}`)
                this.showAddressList = true
              })
            }
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleRegister () {
      this.loader = this.$loading.show()
      this.formRegisterData.seq = this.currentInfoSeq
      WarehouseScService.registerShippingMultichannelInfo(this.formRegisterData)
        .then((response) => {
          store.commit('scshippingmultichannelinfo/setItems', response.data)
          this.$emit('registerShippingInfo')
          this.$emit('close')
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_regis_shipping_info_btn,
        properties: this.formRegisterData
      }
      EventService.postTrackLog(logParams)
    },
    handleUpdate () {
      this.loader = this.$loading.show()
      this.formRegisterData.seq = this.currentInfoSeq
      WarehouseScService.updateShippingMultichannelInfo(this.formRegisterData)
        .then((response) => {
          store.commit('scshippingmultichannelinfo/setItems', response.data)
          this.$emit('registerShippingInfo')
          this.$emit('close')
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.multi_channel_shipping.click_update_shipping_info_btn,
        properties: {
          seq: this.formRegisterData.seq
        }
      }
      EventService.postTrackLog(logParams)
    },
    validateSubmit (fields = []) {
      let hasError = false
      this.validateErrors = {}

      if (fields.length === 0) {
        fields = this.validateFields
      }
      fields.forEach(({ key, limit, message, regex }) => {
        const value = this.formRegisterData[key] || ''
        const isRequired = ['name', 'postalCode', 'prefecture', 'address1', 'phoneNo'].includes(key)

        if (isRequired && !value) {
          this.validateErrors[key] = this.requiredMessage
          hasError = true
        } else if (value.length > limit) {
          this.validateErrors[key] = message.replace('{limit}', limit)
          hasError = true
        } else if (regex && !regex.test(value)) {
          this.validateErrors[key] = message.replace('{limit}', limit)
          hasError = true
        } else {
          this.validateErrors[key] = ''
        }
      })

      return hasError
    },
    handleSubmit () {
      if (this.validateSubmit()) {
        return false
      }

      if (this.selectedInfoItem && Object.keys(this.selectedInfoItem).length) {
        this.handleUpdate()
      } else {
        this.handleRegister()
      }
    },
    setFormRegisterData () {
      if (this.selectedInfoItem) {
        this.formRegisterData.name = this.selectedInfoItem.name
        this.formRegisterData.postalCode = this.selectedInfoItem.postalCode
        this.formRegisterData.prefecture = this.selectedInfoItem.prefecture
        this.formRegisterData.address1 = this.selectedInfoItem.address1
        this.formRegisterData.address2 = this.selectedInfoItem.address2
        this.formRegisterData.phoneNo = this.selectedInfoItem.phoneNo
      }
    }
  },
  mounted () {
    this.setFormRegisterData()
    $('#register-shipping-info-modal').modal('show')
    $('#register-shipping-info-modal').on('hidden.bs.modal', (e) => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    this.$emit('close')
    $('.modal-backdrop').remove()
    setTimeout(() => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: null
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    }, 700)
  }
}
</script>
<style scoped>
.label-required {
  background-color: #c00000;
  color: white;
  text-align: center;
  padding: 0 15px;
  border-radius: 4px;
  margin-left: 10px;
}
.label-any {
  background-color: #002060;
  color: white;
  text-align: center;
  padding: 0 15px;
  border-radius: 4px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/RegisterShippingInfoModal.vue